import { ConnectionsSwitchFields } from './connections_switch_fields'

export const ReturnNextLevel = ({
  item,
  handleChange,
  connectionResponse,
  isAsync,
  testKeyValues,
  currentMode,
  toggleState,
  setToggleState,
  isAvailableTest,
  setIsAvailableTest,
  params,
  setParams
}) => {
  return item?.map((field, index) => {
    return (
      <ConnectionsSwitchFields
        item={field}
        index={index}
        options={field.options}
        handleChange={handleChange}
        connectionResponse={connectionResponse}
        isAsync={isAsync}
        testKeyValues={testKeyValues}
        currentMode={currentMode}
        toggleState={toggleState}
        setToggleState={setToggleState}
        isAvailableTest={isAvailableTest} 
        setIsAvailableTest={setIsAvailableTest}
        params={params}
        setParams={setParams}
      />
    )
  })
}
